import { Outlet, useRouterState } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { ListaConversas } from "@/components/conversas/ListaConversas";
import { Vazio } from "@/components/casca/Vazio";
import { conversasQuery } from "../consultas";

/**
 * A caixa de entrada: lista, conversa e ficha, como num app de mensagem.
 *
 * A lista fica; trocar de conversa troca só o meio e a direita. Mensagem nova
 * chega pelo aviso do servidor e a lista se reordena sozinha.
 *
 * No celular cabe uma coisa por vez: em /conversas, a lista; numa conversa,
 * só ela — com a seta de voltar no cabeçalho.
 */
export function Conversas() {
  const { data } = useSuspenseQuery(conversasQuery());
  const numaConversa = useRouterState({ select: (r) => r.location.pathname.startsWith("/conversas/") });
  return (
    <div className="relative flex h-full min-h-0">
      <ListaConversas
        aguardandoEquipe={data.aguardandoEquipe}
        atendendoVoce={data.atendendoVoce}
        comOAgente={data.comOAgente}
        className={numaConversa ? "hidden md:flex" : "flex"}
      />
      <div className={"relative min-w-0 flex-1 " + (numaConversa ? "flex" : "hidden md:flex")}>
        <Outlet />
      </div>
    </div>
  );
}

/** Aparece quando nenhuma conversa está aberta: clínica sem conversa nenhuma, ou o celular voltando para a lista. */
export function SemConversas() {
  return (
    <div className="bg-chat flex flex-1 items-center justify-center">
      <Vazio icone="conversas" titulo="Nenhuma conversa ainda">
        Assim que alguém escrever para o WhatsApp da clínica, a conversa aparece aqui — com o histórico inteiro, a ficha ao
        lado e o assistente já respondendo.
      </Vazio>
    </div>
  );
}
